import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchClients } from '@/api/clients/clientsApi';
import type { Client } from '@/api/clients/clientsApi.types';
import type { PaginatedResult } from '@/api/pagination.types';
import { ADMIN_LIST_PAGE_SIZE } from '@/constants/adminPagination';
import { CLIENTS_QUERY_KEY } from '@/constants/queryKeys';

export function useClientsQuery(
  page: number,
  search: string,
  status: string
): UseQueryResult<PaginatedResult<Client>, Error> {
  return useQuery({
    queryKey: [...CLIENTS_QUERY_KEY, 'list', page, search, status],
    queryFn: function loadClients() {
      return fetchClients(page, ADMIN_LIST_PAGE_SIZE, search, status);
    },
    placeholderData: keepPreviousData,
  });
}
